import React, {Component} from 'react';
import {Card, CardHeader, CardBody} from "reactstrap";
import DictionariesTable from "../componentsNew/Dictionaries/DictionariesTable";

class DictionariesView extends Component {

  componentDidMount() {
    document.title = 'Słowniki kodowania | ANKIETEO';
  }

  render() {
    return (
      <Card>
        <CardHeader className="p-0">
          <h2><strong>Słowniki</strong></h2>
        </CardHeader>
        <hr className="my-0" />
        <CardBody>
          <DictionariesTable />
        </CardBody>
      </Card>
    )
  }
}

export default DictionariesView